import { useState, useEffect, useCallback, useRef } from 'react';
import { api } from '../api';

// Shared state across all hook consumers — single fetch, multiple readers
let sharedCalls = [];
let sharedListeners = new Set();
let intervalId = null;

function notify() {
  sharedListeners.forEach(fn => fn([...sharedCalls]));
}

async function fetchScheduled() {
  try {
    const data = await api.getScheduledCalls();
    sharedCalls = data;
    notify();
  } catch (_) {}
}

export default function useScheduledCalls() {
  const [calls, setCalls] = useState(sharedCalls);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    const listener = (data) => { if (mounted.current) setCalls(data); };
    sharedListeners.add(listener);

    // First consumer starts the polling
    if (sharedListeners.size === 1) {
      fetchScheduled();
      intervalId = setInterval(fetchScheduled, 30000);
    } else {
      // Late joiners get current data immediately
      setCalls([...sharedCalls]);
    }

    return () => {
      mounted.current = false;
      sharedListeners.delete(listener);
      // Last consumer stops polling
      if (sharedListeners.size === 0 && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);

  const refresh = useCallback(() => fetchScheduled(), []);

  return { scheduledCalls: calls, scheduledCount: calls.length, refreshScheduled: refresh };
}
